import { combineEpics } from "redux-observable";
import { success, error } from "react-notification-system-redux";
import * as api from "./api";

export default combineEpics(
  action$ =>
    action$.ofType(api.editProfile.types.success).map(() =>
      success({
        title: "Profile edited successfully",
        autoDismiss: 15,
        position: "br"
      })
    ),
  action$ =>
    action$.ofType(api.updateAvatar.types.success).map(() =>
      success({
        title: "Avatar updated successfully",
        autoDismiss: 15,
        position: "br"
      })
    ),
  action$ =>
    action$.ofType(api.updateResume.types.success).map(() =>
      success({
        title: "Resume Updated successfully",
        autoDismiss: 15,
        position: "br"
      })
    ),
  action$ =>
    action$.ofType(api.updateResume.types.failure).map(({ payload }) =>
      error({
        title: payload.data.message || payload.data.resume[0],
        autoDismiss: 15,
        position: "br"
      })
    )
);



// WEBPACK FOOTER //
// ./src/modules/user/profile/epic.js